import { useMemo } from 'react';
import { useLanguage } from '@/feature/lang';

export const usePeriodFormatter = () => {
  const { language } = useLanguage();
  return useMemo(() => {
    const formatter = new Intl.DateTimeFormat(language, {
      month: 'long',
      year: 'numeric',
      timeZone: 'UTC',
    });

    // ISO date-only strings parse as midnight UTC, preserving the calendar date.
    return (date: string) => formatter.format(new Date(date));
  }, [language]);
};
